import type { MDXComponents } from 'mdx/types'
import { Link } from 'react-router'
import { InteractiveEmbed } from '@/components/content/InteractiveEmbed'
import { VideoEmbed } from '@/components/content/VideoEmbed'
import { GatedDownload } from '@/components/marketing/GatedDownload'

/**
 * Components available to every MDX document.
 *
 * Internal links route client-side; external ones open in a new tab. The MDX
 * files reference `<VideoEmbed>`, `<InteractiveEmbed>` and `<GatedDownload>`
 * directly, so they must be in scope here.
 */
export const mdxComponents: MDXComponents = {
  GatedDownload,
  InteractiveEmbed,
  VideoEmbed,
  a: ({ href, children, ...props }) => {
    const to = href ?? '#'
    if (/^https?:|^mailto:|^#/.test(to)) {
      return (
        <a href={to} target={to.startsWith('#') ? undefined : '_blank'} rel="noreferrer" {...props}>
          {children}
        </a>
      )
    }
    return (
      <Link to={to} {...props}>
        {children}
      </Link>
    )
  },
  img: ({ src, alt, ...props }) => (
    <img src={typeof src === 'string' ? src : undefined} alt={alt ?? ''} loading="lazy" {...props} />
  ),
}
